module.exports = __webpack_public_path__ + "static/media/entrega.7d1c711a.svg";